import { api } from '../core';

interface UpdateChronologyEntryDateResponse {
  success: boolean;
}

interface UpdateChronologyEntryDateProps {
  abortController?: AbortController;
  entryId: string;
  date: string;
}

const chronologyEntryDateUpdateApi = api.injectEndpoints({
  endpoints: (builder) => ({
    updateChronologyEntryDate: builder.query<UpdateChronologyEntryDateResponse, UpdateChronologyEntryDateProps>({
      query: ({ abortController = new AbortController(), entryId, date }: UpdateChronologyEntryDateProps) => ({
        url: 'chronology/entry/date/update',
        method: 'POST',
        body: {
          entry_id: entryId,
          date
        },
        signal: abortController.signal
      }),
      async onQueryStarted(_, { queryFulfilled }) {
        try {
          await queryFulfilled;
        } catch (error) {
          if (error instanceof Error && error.name === 'AbortError') {
            console.log('Request was aborted');
          } else {
            console.error('Error in updateChronologyEntryDate in onQueryStarted:', error);
          }
        }
      },
      extraOptions: { maxRetries: 0 }
    })
  })
});

/**
 * Export hooks for usage in functional components, which are
 * auto-generated based on the defined endpoints
 */
export const { useLazyUpdateChronologyEntryDateQuery } = chronologyEntryDateUpdateApi;
